export default __webpack_public_path__ + "check-mark.ae76001cd56e2f391217e89fe75f7127.svg";